import { useState, useContext } from 'react'
import AriaModal from 'react-aria-modal'

const ModalContext = React.createContext()

export default function Modal({ children, render: TriggerView, view }) {
  const [state, setState] = useState({
    isActive: false,
    hasEntered: false,
  })

  const activateModal = () => {
    setState({ ...state, isActive: true })
  }

  const onModalEnter = () => {
    setState({ ...state, hasEntered: true })
  }

  const deactivateModal = () => {
    setState({ ...state, hasEntered: false })

    setTimeout(() => {
      setState({ hasEntered: false, isActive: false })
    }, 400)
  }

  let dialogClass = 'modal modal--animated'
  if (view) dialogClass += ` modal--${view}`
  let underlayClass = 'modal-underlay'
  let innerClass = 'modal__inner'
  if (state.hasEntered) {
    dialogClass += ' has-entered'
    underlayClass += ' has-entered'
    innerClass += ' has-entered'
  }

  return (
    <ModalContext.Provider value={{ openModal: activateModal, closeModal: deactivateModal }}>
      <div>
        <TriggerView onClick={activateModal} />

        {state.isActive && (
          <AriaModal
            includeDefaultStyles={false}
            titleText="modal"
            focusDialog={true}
            verticallyCenter={false}
            dialogClass={dialogClass}
            underlayClass={underlayClass}
            onExit={deactivateModal}
            onEnter={onModalEnter}
          >
            <div className={innerClass}>{children}</div>
            <button className="modal__close" onClick={deactivateModal} />
          </AriaModal>
        )}
      </div>
    </ModalContext.Provider>
  )
}

export function useModal() {
  return useContext(ModalContext)
}
